<div *ngIf="modificaMetadatiDocumentoForm && dynamicFields.length > 0">
    <div *ngFor="let field of dynamicFields" class="{{field.size}}">
        <dynamic-form-field [question]="field" [form]="modificaMetadatiDocumentoForm"></dynamic-form-field>
    </div>
</div>
<div>
    <app-detail-table [file]="documento" [isSigned]="false" (onRowsNumberChanges)="onDetaillengthChange($event)" (onRowsChanges)="onDetailChange($event)" #detailTable></app-detail-table>
</div>
